export default "__VITE_ASSET__7d96adfd__"